import Button from "components/button/Button";
import { BiPlus } from "react-icons/bi";
import { CSVGoodsFormProps } from "views/admin/goods/hooks/useCSVGoodsForm";

interface IImagesRender<T> {
  cellData: T;
  onClick: (item: T) => void;
}

export interface ICellImagesRender {
  image_link: string;
  name: string;
}

const CellImagesRender = <T extends CSVGoodsFormProps>(
  props: IImagesRender<T>
) => {
  const { cellData, onClick } = props;

  return (
    <div className="flex items-center gap-2">
      {cellData.image_link?.split(";")?.map((image: string, index: number) =>
        image ? (
          <a
            href={image}
            target="_blank"
            rel="noreferrer"
            key={index}
            className="h-16 w-16 overflow-hidden rounded-lg border-2 border-gray-200 dark:border-white/10"
          >
            <img
              src={image}
              alt={cellData.name}
              className="h-full w-full object-cover"
            />
          </a>
        ) : (
          <Button
            key={index}
            size="fit"
            variant="text-only"
            type="button"
            onClick={() => onClick(cellData)}
            children={
              <div className="flex items-center gap-2">
                <BiPlus className="text-lg" />
                <span className="text-sm font-semibold text-gray-500">
                  Tambah Gambar
                </span>
              </div>
            }
          />
        )
      )}
    </div>
  );
};

export default CellImagesRender;
